import * as Actions from '../actions/actions';
import { processResponse, getResponseActions } from '../../../lib-response-handler/lib/lib-response-handler';

export default class ResponseHandler {
    constructor(settings) {
        this._settings = settings;
    }

    initialize(store, notifications) {
        this._store = store;
        this._throttleTimeoutMap = {};
        this._notifications = notifications;
    }

    getReducer() {
        return (state = {}) => { return state; };
    }

    doesHandleExtensibleRequest(message) {
       return message.messageType === this._settings.messageConstants.extensibleRequest &&
          message.messageSource === this._settings.notificationsApi.extensibleMessageSource;
    }

    doesHandlePollAction(message) {
       return (message.messageType === this._settings.messageConstants.converseRequest ||
             message.messageType === this._settings.messageConstants.requestUnitRequest ||
             message.messageType === this._settings.messageConstants.appeventRequest) &&
          (this._settings.notificationsApi.pollStartActions.length || this._settings.notificationsApi.pollStopActions.length);
    }

    doesHandleResponseThrottling(message) {
       return this.doesHandleExtensibleRequest(message) &&
          this._settings.notificationsApi.throttleMessageOrigins.length &&
          this._settings.notificationsApi.throttleIntervalMS;
    }

    process(message) {
       if (this.doesHandleResponseThrottling(message)) return this.processExtensibleRequest(this.processResponseThrottling(message));
       if (this.doesHandleExtensibleRequest(message)) return this.processExtensibleRequest(message);
       if (this.doesHandlePollAction(message)) return this.processPollAction(message);

       return message;
    }

    processExtensibleRequest(message) {
       if (message.response) {
          message.response.forEach((response) => {
             this._store.dispatch(Actions.stageProcessedResponse({
                stateLocation: this._settings.stateLocations.AlmeNotifications.processedResponse,
                messageType: this._settings.messageConstants.converseRequest, //todo: would probably be better to have this be dynamically set at some point
                response
             }));
          });
       }

       return message;
    }

    processPollAction(message) {
       let processSingle = this.handlePollActionResponse.bind(this);

       return processResponse(message, { processSingle });
    }

    processResponseThrottling(message) {
       let processSingle = (message) => {
          let response = (Array.isArray(message.response)) ? message.response[0] : message.response;
          if (this._settings.notificationsApi.throttleMessageOrigins.some(origin => response.extensionData.MessageOrigin === origin)) {
             if (!this._throttleTimeoutMap[response.extensionData.MessageOrigin]) {
                this._throttleTimeoutMap[response.extensionData.MessageOrigin] = setTimeout(() => {
                   this._throttleTimeoutMap[response.extensionData.MessageOrigin] = false;
                }, this._settings.notificationsApi.throttleIntervalMS);
             } else {
                return null;
             }
          }

          return response;
       };

       return processResponse(message, { processSingle });
    }

    handlePollActionResponse(response) {
       let responseActions = getResponseActions(response).map(action => action.Name);
       if (this._settings.notificationsApi.pollStartActions.some(action => responseActions.indexOf(action) >= 0)) {
          this._notifications.startPolling();
       }
       if (this._settings.notificationsApi.pollStopActions.some(action => responseActions.indexOf(action) >= 0)) {
          this._notifications.stopPolling();
       }

       return response;
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/alme-notificationsapi/src/handlers/notifications-response.js